document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ Infinite Scroll script loaded");

  const grid = document.getElementById("CollectionGrid");
  const pagination = document.getElementById("PaginationContainer");
  const loader = document.querySelector(".o-page-loader");

  if (!grid || !pagination || !loader) {
    console.warn("❌ Required elements not found. Infinite scroll not started.");
    return;
  }

  let nextLink = pagination.querySelector("a[rel='next']");
  if (!nextLink) {
    console.warn("❌ No next page link found.");
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting && nextLink) {
      console.log("🔁 Loading more products from:", nextLink.href);
      loader.style.display = "block";

      fetch(nextLink.href)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newItems = doc.querySelectorAll("#CollectionGrid .o-layout__item");
          newItems.forEach((item) => grid.appendChild(item));

          const newPagination = doc.querySelector("#PaginationContainer");
          if (newPagination) {
            nextLink = newPagination.querySelector("a[rel='next']");
            console.log("✅ Next page link updated:", nextLink?.href);
          } else {
            nextLink = null;
            pagination.remove();
            console.log("✅ No more pages — pagination removed.");
          }
        })
        .catch((err) => console.error("❌ Fetch error:", err))
        .finally(() => {
          loader.style.display = "none";
        });
    }
  });

  observer.observe(pagination);
});

